/**
 * Permission identifiers for the reviewed health report publication module.
 *
 * Mirrors apps/api/src/auth/services/module-catalog.ts so frontend gating
 * cannot diverge from backend RBAC.
 */
import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const HEALTH_REPORT_PUBLICATION_PERMISSIONS = {
  READ: 'health_report_publications:read',
  REVIEW: 'health_report_publications:review',
  PUBLISH: 'health_report_publications:publish',
} as const;

export function canSeeHealthReportPublicationMenu(
  permissions: readonly string[],
): boolean {
  return hasPermission(permissions, HEALTH_REPORT_PUBLICATION_PERMISSIONS.READ);
}
